import { GEO_TO_COUNTRY_CODE } from "@/lib/shared/constants";
import type { ICountry } from "@/lib/shared/constants";

const LANGUAGE_COUNTRY_FALLBACKS: Record<string, string> = {
  de: "DE",
  fr: "FR",
  ja: "JP",
  zh: "CN",
};

export function getBrowserCountryCode(languages: readonly string[]): string | undefined {
  for (const languageTag of languages) {
    const normalized = languageTag.trim().replace(/_/g, "-");
    if (!normalized) continue;

    const [language, region] = normalized.split("-");
    const regionCode = region?.toUpperCase();
    if (regionCode && GEO_TO_COUNTRY_CODE[regionCode]) {
      return GEO_TO_COUNTRY_CODE[regionCode];
    }

    const languageCode = language?.toLowerCase();
    if (!languageCode) continue;
    if (LANGUAGE_COUNTRY_FALLBACKS[languageCode]) {
      return LANGUAGE_COUNTRY_FALLBACKS[languageCode];
    }
    if (languageCode === "en") return "GB";
  }

  return undefined;
}

export function resolveInitialCountryCode({
  urlCountry,
  savedCountry,
  browserLanguages,
  countries,
}: {
  urlCountry?: string | null;
  savedCountry?: string | null;
  browserLanguages: readonly string[];
  countries: ICountry[];
}): string | undefined {
  const candidates = [urlCountry, savedCountry].map((value) => {
    const normalized = value?.trim().toUpperCase();
    return normalized ? (GEO_TO_COUNTRY_CODE[normalized] ?? normalized) : undefined;
  });

  for (const candidate of candidates) {
    if (candidate && countries.some((country) => country.countryCode === candidate)) {
      return candidate;
    }
  }

  const browserCountry = getBrowserCountryCode(browserLanguages);
  return browserCountry && countries.some((country) => country.countryCode === browserCountry)
    ? browserCountry
    : undefined;
}

export function removeCountryQueryParam(url: URL): URL {
  const nextUrl = new URL(url);
  nextUrl.searchParams.delete("country");
  return nextUrl;
}
